import { render, staticRenderFns } from "./AddWhatsAppPersonal.vue?vue&type=template&id=36a03d56"
import script from "./AddWhatsAppPersonal.vue?vue&type=script&lang=js"
export * from "./AddWhatsAppPersonal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports